//
// カスタム項目設定画面
//
document.addEventListener("DOMContentLoaded", (_event) => {
  const pages = document.getElementsByClassName("form-custom_form");
  if (pages.length == 0) return;

  // 設定ONの場合のみ必須入力を操作可能にする
  const activateCheckboxes = document.querySelectorAll(
    "[data-required-checkbox]"
  );

  activateCheckboxes.forEach((activateCheckbox) => {
    const requiredCheckbox = document.querySelector(
      `#${activateCheckbox.dataset.requiredCheckbox}`
    );

    activateCheckbox.addEventListener("click", (event) => {
      if (event.target.checked) {
        requiredCheckbox.disabled = false;
      } else {
        requiredCheckbox.disabled = true;
        requiredCheckbox.checked = false;
      }
    });
  });
});
